import { get } from "@/api/implementation/app/index.js";

import { getPaginated } from "@/api/implementation/app/wrapper.js";

export const publicApiEndpoints = (clientId) =>
    get(`client/${clientId}/public-api-log/type`);

export function index(clientId, page, perPage, search, sortBy, descending, params) {
  const data = {
    ...params,
    isSuccessful: !params?.showSuccessful ? 0 : undefined,
  };

  delete data.showSuccessful;

  return getPaginated(`client/${clientId}/public-api-log`, page, perPage, search, sortBy, descending, data);
}
